<template>
  <v-container max-width="100%" style="margin-top: 2%">

    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="12" md="2">
            <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
              item-value="id_empresa" clearable :label="$tc('company.self', 1)"
              @change="onEmpresaSelectChanged"></v-autocomplete>
          </v-col>
          <!-- adicionar unidade -->
          <v-col cols="12" sm="6" md="3">
            <MultiplaEscolha 
              :items="unidadesItens"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <!-- termina unidade -->
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')" @input="onDateChanged">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')" @input="onDateChanged">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaRelatorio">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="5">
            <v-autocomplete v-model="idLinhaSelected" :items="linhasSelect" item-text="nome_linha" item-value="id_linha"
              clearable :label="$tc('line.self', 1)" multiple @change="linhasSelectChanged"
              :disabled="isLinhaSelectDisabled"></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-data-table :headers="headers" :items="viagensFiltered" sort-by="inicio" dense class="elevation-7" locale="pt"
      :loading="loadingViagens" :loading-text="$t('system.messages.loading')" :search="search"
      style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">{{ $t('relStatusTrip.title') }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('system.labels.search')" single-line
            hide-details></v-text-field>
          <v-spacer></v-spacer>

          <vue-json-to-csv :json-data="viagensFiltered" :csv-title="'statusviagens'" separator=";">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('system.labels.exportToCsv') }}</span>
            </v-tooltip>
          </vue-json-to-csv>

          <export-table-pdf :title="$t('relStatusTrip.headers.statusRealized')" :content="viagensFiltered" :headers="headers"
            filename="statusviagens"></export-table-pdf>
        </v-toolbar>
      </template>

      <template v-slot:item.p_completas="{ item }">
        <PercentItem :value="item.p_completas"></PercentItem>
      </template>

      <template v-slot:item.p_sem_inicio="{ item }">
        <PercentItem :value="item.p_sem_inicio"></PercentItem>
      </template>

      <template v-slot:item.p_sem_fim="{ item }">
        <PercentItem :value="item.p_sem_fim"></PercentItem>
      </template>

      <template v-slot:item.p_manuais="{ item }">
        <PercentItem :value="item.p_manuais"></PercentItem>
      </template>

      <template v-slot:item.p_automaticas="{ item }">
        <PercentItem :value="item.p_automaticas"></PercentItem>
      </template>

    </v-data-table>

  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import VueJsonToCsv from "vue-json-to-csv";
import ExportTablePdf from "./ExportTablePdf.vue";
import DateUtils from "../utils/dateutils";
import PercentItem from "./PercentItem.vue";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

export default {
  components: {
    VueJsonToCsv,
    ExportTablePdf,
    PercentItem,
    MultiplaEscolha,
  },
  data: () => ({
    search: "",
    user: null,
    token: null,
    mensagemAutorizacaoDialog: "",
    autorizacaoDialog: false,
    showConfirmButton: true,
    formValidado: false,
    loadingViagens: false,
    timeProps: {
      useSeconds: true,
    },
    dti: null,
    dtf: null,
    idEmpresaSelected: null,
    idLinhaSelected: [],
    empresas: [],
    linhasSelect: [],
    unidades: [],
    unidadesSelecionadas: [],
    viagens: [],
    viagensFiltered: [],
    isLinhaSelectDisabled: false,
    config: null,
  }),
  computed: {
    headers() {
      return [
        { text: this.$t('relStatusTrip.headers.id'), value: "id_linha", align: " d-none" },
        { text: this.$t('relStatusTrip.headers.line'), value: "cod_linha" },
        { text: this.$t('relStatusTrip.headers.date'), value: "data_extenso" },
        { text: this.$t('relStatusTrip.headers.total'), value: "total" },
        { text: this.$t('relStatusTrip.headers.completed'), value: "completas" },
        { text: this.$t('relStatusTrip.headers.completedPercent'), value: "p_completas" },
        { text: this.$t('relStatusTrip.headers.noInitial'), value: "sem_inicio" },
        { text: this.$t('relStatusTrip.headers.noInitialPercent'), value: "p_sem_inicio" },
        { text: this.$t('relStatusTrip.headers.noEnd'), value: "sem_fim" },
        { text: this.$t('relStatusTrip.headers.noEndPercent'), value: "p_sem_fim" },
        { text: this.$t('relStatusTrip.headers.manuals'), value: "manuais" },
        { text: this.$t('relStatusTrip.headers.manualsPercent'), value: "p_manuais" },
        { text: this.$t('relStatusTrip.headers.automatics'), value: "automaticas" },
        { text: this.$t('relStatusTrip.headers.automaticsPercent'), value: "p_automaticas" },
      ];
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
      }
    },
    yesterday() {
      let td = new Date();
      td.setDate(td.getDate() - 1);
      return td.toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.yesterday
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min
      }
    },
    unidadesItens() {
      return this.unidades;
    }
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
    },
    unidadesSelecionadas() {
      this.aplicarFiltroUnidades();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.getConfig();
    this.initialize();
  },
  mounted() { },
  methods: {

    initialize() {
      this.populaEmpresas();
      this.populaUnidades();
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
        },
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
      });
    },
    populaLinhasSelect(id_empresa) {
      apiController.request(apiController.endpoints.getLinhasporempresa, {
        params: { id: id_empresa },
        onSuccess: (response) => {
          this.linhasSelect = response.data;
        },
      });
    },
    populaViagens() {
      this.loadingViagens = true;
      let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
      let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);
      // Sem linhas selecionadas e sem empresa: null = todas as linhas (evita IN () inválido)
      let idlinhas = null;

      if (this.idLinhaSelected.length > 0) {
        idlinhas = this.idLinhaSelected;
      } else if (this.linhasSelect.length > 0) {
        idlinhas = this.linhasSelect.map((l) => l.id_linha);
      }

      let temp = {
        idlinhas: idlinhas,
        dti: dataInicial,
        dtf: dataFinal
      }

      apiController.request(apiController.endpoints.getAgregadostatusviagens, {
        data: temp,
        onSuccess: (response) => {
          this.viagens = response.data;
          this.aplicarFiltroUnidades();
          this.loadingViagens = false;
        },
        onError: () => {
          this.loadingViagens = false;
        },
      });
    },
    populaRelatorio() {
      this.$refs.form.validate();
      if (this.formValidado) {
        this.viagens = [];
        this.viagensFiltered = [];
        this.populaViagens();
        this.$nextTick(() => { this.$refs.form.resetValidation(); });
      }
    },
    linhasSelectChanged() {

    },
    onEmpresaSelectChanged() {
      this.idLinhaSelected = [];
      if (this.idEmpresaSelected == null) {
        this.linhasSelect = [];
        return;
      }
      this.populaLinhasSelect(this.idEmpresaSelected);
    },
    populaUnidades() {
      apiController.request(apiController.endpoints.getallUnidadesativas, {
        onSuccess: (response) => {
          this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...(response.data || [])];
        },
      });
    },
    aplicarFiltroUnidades() {
      if (this.unidadesSelecionadas.length > 0) {
        const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
        this.viagensFiltered = this.viagens.filter((v) => {
          return selecionadas.includes(Number(v.id_unidade));
        });
      } else {
        this.viagensFiltered = this.viagens;
      }
    },
    onDateChanged() {

    },
  },
};
</script>